import React, { useState } from "react";
import { Search, ScanLine } from "lucide-react";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import SearchResultModal from "./SearchResultModal";
import BarcodeScannerModal from "./BarcodeScannerModal";

/* استعلام من السيرفر */
const searchByPassport = async (passportNumber) => {
  try {
    const res = await fetch(`/api/transactions.php?passport=${encodeURIComponent(passportNumber)}`);
    const data = await res.json();
    return data && Object.keys(data).length ? data : null;
  } catch (err) {
    return null;
  }
};

// ✅ تنظيف/استخراج رقم الجواز من نص الباركود
const extractPassportNumber = (raw) => {
  if (!raw) return "";
  // خذ فقط حروف/أرقام (بدون رموز)
  const cleaned = raw.toString().trim().toUpperCase().replace(/[^A-Z0-9]/g, "");

  // لو كان فيه نص طويل، خذ آخر 9-12 كحالة شائعة (عدّل حسب واقع بياناتك)
  if (cleaned.length > 12) return cleaned.slice(-12);

  return cleaned;
};

const HeroSection = () => {
  const [passportNumber, setPassportNumber] = useState("");
  const [searchResult, setSearchResult] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(false);

  // ✅ ماسح الباركود
  const [showScanner, setShowScanner] = useState(false);

  const doSearch = async (value) => {
    const v = value.trim();
    if (!v) return;

    setLoading(true);
    const result = await searchByPassport(v);
    setSearchResult(result);
    setShowModal(true);
    setLoading(false);
  };

  const handleSearch = async (e) => {
    e.preventDefault();
    await doSearch(passportNumber);
  };

  const handleDetected = async (rawText) => {
    const extracted = extractPassportNumber(rawText);
    if (!extracted) return;

    setPassportNumber(extracted);
    // ابحث مباشرة بعد المسح
    await doSearch(extracted);
  };

  return (
    <>
      <section
        className="relative min-h-screen flex items-center justify-center pt-32 pb-20 overflow-hidden"
        style={{
          backgroundImage:
            "url(https://images.unsplash.com/photo-1586528116311-ad8dd3c8310d?w=1920&q=80)",
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundAttachment: "fixed",
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-br from-gray-900/90 via-gray-800/80 to-green-900/70"></div>

        <div className="relative z-10 container mx-auto px-4 text-center">
          <h2 className="text-4xl md:text-6xl font-bold text-white mb-6">
            الاستعلام عن المعاملة
          </h2>

          <p className="text-base md:text-lg text-gray-200 mb-10">
            أدخل رقم الجواز لمعرفة حالة معاملتك
          </p>

          <form onSubmit={handleSearch} className="max-w-2xl mx-auto">
            {/* ✅ على الجوال نخليها عمودية، على الديسكتوب صف */}
            <div className="flex flex-col md:flex-row gap-3 md:gap-4 bg-white/10 p-4 rounded-xl">
              <Input
                type="text"
                inputMode="latin"
                placeholder="رقم الجواز"
                value={passportNumber}
                onChange={(e) => setPassportNumber(e.target.value)}
                className="flex-1 h-14 text-lg text-right"
                dir="rtl"
              />

              <div className="flex gap-3">
                {/* ✅ زر المسح: يظهر بالجوال فقط */}
                <Button
                  type="button"
                  onClick={() => setShowScanner(true)}
                  className="h-14 px-5 text-lg bg-white/15 text-white border border-white/20 md:hidden"
                  disabled={loading}
                >
                  <ScanLine className="w-5 h-5 ml-2" />
                  مسح
                </Button>

                <Button
                  type="submit"
                  disabled={loading}
                  className="h-14 px-10 text-lg bg-green-600 text-white flex-1"
                >
                  <Search className="w-5 h-5 ml-2" />
                  {loading ? "جاري البحث" : "بحث"}
                </Button>
              </div>
            </div>

            {/* ✅ تلميح للجوال */}
            <p className="text-xs text-gray-200 mt-3 md:hidden" dir="rtl">
              يمكنك استخدام زر “مسح” لقراءة باركود/QR من الجواز (إن وجد).
            </p>
          </form>
        </div>
      </section>

      <BarcodeScannerModal
        isOpen={showScanner}
        onClose={() => setShowScanner(false)}
        onDetected={handleDetected}
      />

      <SearchResultModal
        isOpen={showModal}
        onClose={() => setShowModal(false)}
        result={searchResult}
      />
    </>
  );
};

export default HeroSection;
